import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { addYears } from "@dffedb/util";

import { EdhRepository } from "./edh.repository";
import { EdhDokument } from "./model/edh-dokument.model";

@Injectable({ providedIn: "root" })
export class EdhService {
    constructor(private readonly repository: EdhRepository) {}

    public hentDokumenterForAktuelInstallation(antalAarTilbageITiden: number = -1): Observable<EdhDokument[]> {
        // Send antalAarTilbage parameter til API'et i stedet for at filtrere på klienten
        return this.repository.hentDokumenterForAktuelInstallation(antalAarTilbageITiden);
    }

    public markerAlleDokumenterLaest(): Observable<void> {
        return this.repository.markerAlleDokumenterLaest();
    }

    public hentDokumentUrlerForAktuelBruger(dokumentnummer: number): Observable<string[]> {
        return this.repository.hentDokumentUrlerForAktuelBruger(dokumentnummer);
    }

    public hentDokumentUrlerForAktuelInstallation(dokumentnummer: number): Observable<string[]> {
        return this.repository.hentDokumentUrlerForAktuelInstallation(dokumentnummer);
    }
}
